import { Box, type BoxProps } from '@mantine/core';
import type { ReactNode } from 'react';

import * as classes from './styles.css';

type SurfacePanelProps = BoxProps & {
  className?: string;
  children?: ReactNode;
};

export default function SurfacePanel({
  className,
  children,
  ...props
}: SurfacePanelProps) {
  const rootClassName = className
    ? `${classes.root} ${className}`
    : classes.root;

  return (
    <Box className={rootClassName} {...props}>
      {children}
    </Box>
  );
}
